export const isProduction = () => {
  return process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT === "production";
};
